import { useDispatch, useSelector } from 'react-redux'

import {
  addTranscript,
  type CompositeData,
  resetTranscript,
  SessionState,
  setAvatarId,
  setAvatarReady,
  setCompositeData,
  setCreditBalance,
  setDataChannel,
  setIsFileUploading,
  setIsSubsDataLoading,
  setPersonaData,
  setPromptData,
  setSecondsBalance,
  setSessionId,
  setSocketId,
  setVoicesList,
  setWebRTCStatus,
  Voice,
} from '../../store/reducers/sessionReducer'
import { RootState } from '../../store/store'
import { SessionMentor } from '../../types/mentor'
import { TranscriptMessage } from '../../types/transcript'

// Avatar hooks
export const useSession = () => {
  const avatarId = useSelector(
    (state: RootState) => state.sessionReducer.avatarId,
  )
  const sessionId = useSelector(
    (state: RootState) => state.sessionReducer.sessionId,
  )
  const avatarReady = useSelector(
    (state: RootState) => state.sessionReducer.avatarReady,
  )
  const dataChannel = useSelector(
    (state: RootState) => state.sessionReducer.dataChannel,
  )
  const personaData = useSelector(
    (state: RootState) => state.sessionReducer.personaData,
  )
  const promptData = useSelector(
    (state: RootState) => state.sessionReducer.promptData,
  )
  const secondsBalance = useSelector(
    (state: RootState) => state.sessionReducer.secondsBalance,
  )
  const creditBalance = useSelector(
    (state: RootState) => state.sessionReducer.creditBalance,
  )
  const isSubsDataLoading = useSelector(
    (state: RootState) => state.sessionReducer.isSubsDataLoading,
  )
  const isFileUploading = useSelector(
    (state: RootState) => state.sessionReducer.isFileUploading,
  )
  const transcripts = useSelector(
    (state: RootState) => state.sessionReducer.transcripts,
  )
  const transcript = useSelector(
    (state: RootState) => state.sessionReducer.transcript,
  )
  const socketId = useSelector(
    (state: RootState) => state.sessionReducer.socketId,
  )

  const dispatch = useDispatch()

  return {
    dataChannel,
    avatarId,
    sessionId,
    avatarReady,
    personaData,
    promptData,
    secondsBalance,
    creditBalance,
    isFileUploading,
    transcripts,
    transcript,
    isSubsDataLoading,
    socketId,
    setAvatarId: (id: string) => dispatch(setAvatarId(id)),
    setSessionId: (id: string | undefined) => dispatch(setSessionId(id)),
    setAvatarReady: (ready: boolean) => dispatch(setAvatarReady(ready)),
    setDataChannel: (channel: RTCDataChannel | null) =>
      dispatch(setDataChannel(channel)),
    setPersonaData: (personaData: SessionMentor | null) =>
      dispatch(setPersonaData(personaData)),
    setPromptData: (promptData: string) => dispatch(setPromptData(promptData)),
    setSecondsBalance: (balanse: number) =>
      dispatch(setSecondsBalance(balanse)),
    setCreditBalance: (balance: number) => dispatch(setCreditBalance(balance)),
    setIsFileUploading: (data: boolean) => dispatch(setIsFileUploading(data)),
    addTranscript: (message: TranscriptMessage) =>
      dispatch(addTranscript(message)),
    resetTranscript: (message: string) => dispatch(resetTranscript(message)),
    setIsSubsDataLoading: (isLoading: boolean) =>
      dispatch(setIsSubsDataLoading(isLoading)),
    setSocketId: (id: string | null) => dispatch(setSocketId(id)),
  }
}

export const useAudioVideo = () => {
  const webRTCStatus = useSelector(
    (state: RootState) => state.sessionReducer.webRTCStatus,
  )

  const dispatch = useDispatch()

  return {
    webRTCStatus,
    setWebRTCStatus: (webRTCStatus: SessionState['webRTCStatus']) =>
      dispatch(setWebRTCStatus(webRTCStatus)),
  }
}

export const useCompositeData = () => {
  const compositeData = useSelector(
    (state: RootState) => state.sessionReducer.compositeData,
  )
  const voicesList = useSelector(
    (state: RootState) => state.sessionReducer.voicesList,
  )

  const dataChannel = useSelector(
    (state: RootState) => state.sessionReducer.dataChannel,
  )

  const dispatch = useDispatch()

  return {
    compositeData,
    voicesList,
    dataChannel,
    setCompositeData: (data: CompositeData | null) =>
      dispatch(setCompositeData(data)),
    setVoicesList: (data: Voice[]) => dispatch(setVoicesList(data)),
  }
}
